import NiceModal from "@ebay/nice-modal-react";
import { SpinnerModal } from "@/comps/SpinnerModal";

export const spinnerKey = "spinner";

NiceModal.register(spinnerKey, SpinnerModal);
